module.exports = __webpack_public_path__ + "img/add.1b2ee0a8.svg";